// Imports
import { Link } from "react-router-dom"

const commonProps = {
    allColors: (
        <>
            Any <Link to="/styles/colors">colors from Fajny CSS</Link>, or any
            other color
        </>
    ),
    colorsShort:
        '"primary" | "secondary" | "success" | "danger" | "warning" | "gray" | "black" | "white"',
    colorsHover:
        '"primary" | "secondary" | "success" | "danger" | "warning" | "white"',
    fajnyIcons: (
        <>
            Any icon from <Link to="/icons">Fajny icons</Link>
        </>
    ),
    requiredFajnyIcon: (
        <>
            Yes, if you want to use one of <Link to="/icons">Fajny icons</Link>
        </>
    ),
    textAlign:
        '"left" | "center" | "right" | "justify" | "inherit" | "initial" | "revert" | "revert-layer" | "unset"',
    spacers: '"xxl" | "xl" | "l" | "m" | "s" | "xs" | "xxs"',
    allShadows: '"xxl" | "xl" | "l" | "m" | "s" | "xs"',
    gridJustifyItems: '"start" | "end" | "center" | "stretch"',
    gridAlignItems: '"start" | "end" | "center" | "stretch"',
    gridJustifyContent:
        '"start" | "end" | "center" | "stretch" | "space-around" | "space-between" | "space-evenly"',
    gridAlignContent:
        '"start" | "end" | "center" | "stretch" | "space-around" | "space-between" | "space-evenly"',
    flexAlign: '"stretch" | "flex-start" | "flex-end" | "center" | "baseline"',
    flexJustify:
        '"flex-start" | "flex-end" | "center" | "space-between" | "space-around" | "space-evenly"',
    objectFit:
        '"fill" | "contain" | "cover" | "none" | "scale-down" | "inherit" | "initial" | "revert" | "revert-layer" | "unset"',
    validationInput: '"not-passed" | "passed"'
}

export default commonProps
